module.exports = __webpack_public_path__ + "img/khcz.6360b47f.png";